(function () {
  var focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');
  var lastSearchTrigger = null;
  var lastMenuTrigger = null;

  function getFocusable(container) {
    if (!container) return [];
    return Array.prototype.slice.call(container.querySelectorAll(focusableSelector)).filter(function (element) {
      return element.offsetWidth > 0 || element.offsetHeight > 0 || element === document.activeElement;
    });
  }

  function trapFocus(e, container) {
    if (e.key !== 'Tab') return;

    var focusable = getFocusable(container);
    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function initSearch() {
    var overlay = document.getElementById('rb-search-overlay');
    if (!overlay) return;

    var openButtons = [
      document.getElementById('rb-search-open'),
      document.getElementById('rb-mobile-search-open')
    ].filter(Boolean);
    var closeBtn = document.getElementById('rb-search-close');
    var input = overlay.querySelector('.rb-search-input');
    var form = overlay.querySelector('.rb-search-form');

    function setSearchButtonsExpanded(isExpanded) {
      openButtons.forEach(function (btn) {
        btn.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      });
    }

    function openSearch(trigger) {
      lastSearchTrigger = trigger || document.activeElement;
      overlay.classList.add('active');
      overlay.setAttribute('aria-hidden', 'false');
      setSearchButtonsExpanded(true);
      document.body.classList.add('rb-search-open');
      window.setTimeout(function () {
        if (input) input.focus();
      }, 280);
    }

    function closeSearch() {
      overlay.classList.remove('active');
      overlay.setAttribute('aria-hidden', 'true');
      setSearchButtonsExpanded(false);
      document.body.classList.remove('rb-search-open');

      if (lastSearchTrigger && typeof lastSearchTrigger.focus === 'function') {
        lastSearchTrigger.focus();
      }
    }

    openButtons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openSearch(btn);
      });
    });

    if (closeBtn) closeBtn.addEventListener('click', closeSearch);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeSearch();
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        var query = input && input.value ? input.value.trim() : '';
        if (!query) {
          e.preventDefault();
          if (input) input.focus();
        }
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('active')) closeSearch();
    });

    overlay.addEventListener('keydown', function (e) {
      trapFocus(e, overlay);
    });
  }

  function initMobileMenu() {
    var toggle = document.getElementById('rb-mobile-toggle');
    var menu = document.getElementById('rb-mobile-menu');
    var closeBtn = document.getElementById('rb-mobile-close');
    if (!toggle || !menu) return;

    function openMenu(trigger) {
      lastMenuTrigger = trigger || document.activeElement;
      menu.classList.add('active');
      menu.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      window.setTimeout(function () {
        var focusable = getFocusable(menu);
        if (focusable.length) focusable[0].focus();
      }, 120);
    }

    function closeMenu() {
      menu.classList.remove('active');
      menu.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');

      if (lastMenuTrigger && typeof lastMenuTrigger.focus === 'function') {
        lastMenuTrigger.focus();
      }
    }

    toggle.addEventListener('click', function () {
      if (menu.classList.contains('active')) {
        closeMenu();
      } else {
        openMenu(toggle);
      }
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        closeMenu();
      });
    }

    menu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', closeMenu);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('active')) closeMenu();
    });

    menu.addEventListener('keydown', function (e) {
      trapFocus(e, menu);
    });
  }

  function initStickyNav() {
    var row1 = document.getElementById('rb-navbar-row1');
    var row2 = document.getElementById('rb-navbar-row2');
    var placeholder = document.getElementById('rb-row2-placeholder');
    if (!row1 || !row2 || !placeholder) return;

    var stickyPoint = 0;
    var isStuck = false;
    var ticking = false;
    var HYSTERESIS = 10; // px gap to prevent jitter at threshold

    function getStickyPoint() {
      var scrollY = window.pageYOffset || document.documentElement.scrollTop;
      return scrollY + row1.getBoundingClientRect().bottom;
    }

    function updatePlaceholderHeight() {
      placeholder.style.height = row2.offsetHeight + 'px';
    }

    function refreshStickyPoint() {
      updatePlaceholderHeight();
      stickyPoint = getStickyPoint();
      handleSticky();
    }

    function handleSticky() {
      var scrollY = window.pageYOffset || document.documentElement.scrollTop;
      if (!isStuck) stickyPoint = getStickyPoint();

      if (!isStuck && scrollY >= stickyPoint) {
        isStuck = true;
        updatePlaceholderHeight();
        row2.classList.add('stuck');
        placeholder.classList.add('visible');
      } else if (isStuck && scrollY < stickyPoint - HYSTERESIS) {
        isStuck = false;
        row2.classList.remove('stuck');
        placeholder.classList.remove('visible');
      }
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(handleSticky);
      }
    }

    window.addEventListener('load', function () {
      refreshStickyPoint();
    });
    window.addEventListener('resize', function () {
      isStuck = false;
      row2.classList.remove('stuck');
      placeholder.classList.remove('visible');
      refreshStickyPoint();
    });
    window.addEventListener('scroll', onScroll, { passive: true });
    updatePlaceholderHeight();
    handleSticky();
  }

  function init() {
    initSearch();
    initMobileMenu();
    initStickyNav();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
